import { createContext, ReactNode } from "react";

interface IData {
  page: {
    data?: any;
    error?: any;
  };
  isSafeMode?: boolean;
}

const initialData: IData = {
  page: {
    data: null,
    error: null,
  },
  isSafeMode: false,
};

export const PageContext = createContext(initialData);

interface IProps extends IData {
  children: ReactNode;
}

export const PageProvider = ({
  page = initialData.page,
  isSafeMode = false,
  children,
}: IProps) => {
  return (
    <PageContext.Provider value={{ page, isSafeMode }}>
      {children}
    </PageContext.Provider>
  );
};
